import React, { useEffect } from "react";
import "./AwardsSection.css";
import { FaAward } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

import { 
  FaPhoneAlt,
  FaEnvelope,
  
  FaEnvelopeOpenText,
 FaHeadset } from "react-icons/fa";
const awards = [
  {
   
    title: "Gold Medal",
    message:
      "Special Award from NPCI on Aadhaar Enabled Payments and Digital Wallet on 08-March-2017",
    image: "/assets/images/award1.png",
  },
  {
   
    title: "National President’s Prize",
    message:
      "MD & CEO Mr. Srinivasa Katuri addressing ThinkNext 2016 gathering on 7th December 2016",
    image: "/assets/images/award2.png",
  },
  {
 
    title: "Equity Prize",
    message:
      "TA Team with Microsoft India Chairman, Mr. Bhaskar Pramanik at ThinkNext 2016 on 7th December 2016",
    image: "/assets/images/award3.png",
  },
];

const AwardsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
    <section className="awards-section">
      <h2 className="section-title1">
        <FaAward className="trophy-icon" /> Awards
      </h2>
      <div className="awards-grid">
        {awards.map((award, idx) => (
          <div className="award-card modern" key={idx} data-aos="zoom-in">
            <div className="image-container">
              <img src={award.image} alt={award.name} className="award-image" />
            </div>
            <div className="award-content">
              <h3 className="award-title" style={{color:'orange'}}>{award.title}</h3>
              <p className="award-message">“{award.message}”</p>
             
            </div>
          </div>
        ))}
      </div>
    </section>
<section className="ta-support-section">
  <div className="ta-support-container">

    {/* Header Area */}
    <div className="ta-support-header">
      <span className="ta-support-badge">TA Help Center</span>
      <h3><b>TA Contact Support</b></h3>

      <p className="ta-support-subtext">
        Contact us anytime — we’re happy to help!
      </p>
    </div>

    {/* Cards Row */}
    <div
      style={{
        display: "flex",
        gap: "40px",              // 🔥 increased gap
        flexWrap: "wrap",
        justifyContent: "center",
       
      }}
    >

      {/* Card 1 */}
      <div 
        className="ta-support-card"
        style={{
          width: "400px",        // 🔥 increased width
          padding: "20px"
        }}
      >
        <div className="ta-card-content">
          <h3 style={{paddingBottom:"10px",color:"black",fontWeight:"800"}}>Nodal Officer 1</h3>

          <p style={{ margin: "8px 0", display: "flex", alignItems: "center", gap: "8px" }}>
  <FaPhoneAlt style={{ color: "#007bff" }} />
  <p  style={{color:"gray"}} >
    +91 8123910785
  </p>
</p>

<p style={{ margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
  <FaEnvelope style={{ color: "#28a745" }} />
  <p  style={{color:"gray"}} >
   siddhartha.d@taipl.in
  </p>
</p>
        </div>
      </div>

      {/* Card 2 */}
      <div 
        className="ta-support-card"
        style={{
          width: "400px",        // 🔥 same width
          padding: "20px"
        }}
      >
        <div className="ta-card-content">
          <h3 style={{paddingBottom:"10px",color:"black",fontWeight:'800'}}>Nodal Officer 2</h3>

       <p style={{ margin: "8px 0", display: "flex", alignItems: "center", gap: "8px" }}>
  <FaPhoneAlt style={{ color: "#007bff" }} />
  <p style={{color:"gray"}} >
    +91 9685745896
  </p>
</p>

<p style={{ margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
  <FaEnvelope style={{ color: "#28a745" }} />
  <p  style={{color:"gray"}}>
    kirankumar.p@taipl.in
  </p>
</p>
        </div>
      </div>

    </div>
  </div>
</section>
        </>
  );
};

export default AwardsSection;
